"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Clipboard` instead */
export const Clipboard = createSVGIcon(
  <>
    <path
      d="M18.018 17.562a2 2 0 0 0 .482-1.3V5.5h-13v15h9.08a2 2 0 0 0 1.519-.7z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 2.5h-5.448a3.33 3.33 0 0 0-6.1 0H3.5a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h17a1 1 0 0 0 1-1v-19a1 1 0 0 0-1-1ZM15.5 8.5h-7M15.5 12.5h-7M13 16.5H8.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Clipboard",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Copy",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
    color: Core.icon.default,
  })
);
